module.exports = __webpack_public_path__ + "img/logo-vi.416f38cb.png";